import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../actions/RegisterSeminarManagerment';
import RegisterSeminarManagerment from '../../../selectors/RegisterSeminarManagerment';
import withAuth from '../../../common/WithAuth';
import ListRegisterSeminar from '../../../pages/Admin/RegisterSeminarManagerment/ListRegisterSeminar';

const mapStateToProps = (state) => {
    const registSeminarResults = RegisterSeminarManagerment.createRegisterSeminarManagermentResultsSelector()(state);
    const isLoading = state.registerSeminarManagerment.get.isFetching
    || state.registerSeminarManagerment.update.isFetching
    || state.registerSeminarManagerment.resentMail.isFetching
    || state.registerSeminarManagerment.getDetail.isFetching;

    return {
        registSeminarResults,
        detailOrderSeminar: state.registerSeminarManagerment.getDetail.data?.seminars,
        registSeminars: state.registerSeminarManagerment.get.data,
        listDetailOrderSeminar: state.registerSeminarManagerment.getDetail.data,
        updateStatusSuccess: state.registerSeminarManagerment.update.isSuccess,
        errorsUpdateStatus: state.registerSeminarManagerment.update.errors,
        resentMailSuccess: state.registerSeminarManagerment.resentMail.isSuccess,
        errorsResentMail: state.registerSeminarManagerment.resentMail.errors,
        isLoading,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchListRegisterSeminar: (params) => {
        dispatch(Actions.GetListRegistSeminarRequested(params));
    },
    updateRegistSeminar: (params) => {
        dispatch(Actions.UpdateStatusRegistSeminarRequested(params));
    },
    clearListRegistSeminar: () => {
        dispatch(Actions.ClearListLRegistSeminar());
    },
    clearDetailSeminar: () => {
        dispatch(Actions.clearDetailOrderSeminarData());
    },
    getDetailOrder: (params) => {
        dispatch(Actions.getDetailOrderSeminarRequested(params));
    },
    clearUpdateStatus: () => {
        dispatch(Actions.ClearUpdateStatusRegistSeminarRequested());
    },
    resentMailOrder: (param) => {
        dispatch(Actions.resentMailSeminarRequested(param));
    },
    clearResentMail: () => {
        dispatch(Actions.clearMailSeminar());
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListRegisterSeminar);
